import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import fondo_inicio from '../assets/images/charity/bg02.jpg'
//import fondo_inicio from '../assets/images/blog/15.jpg'
import intro_01 from '../assets/images/psicologo/intro_05.png'
import intro_torre from '../assets/images/Brochure_Deymed_Duomag/1.png'
import intro_08 from '../assets/images/Brochure_Deymed_Duomag/8.png'
import intro_10 from '../assets/images/Brochure_Deymed_Duomag/10.png'
import intro_11 from '../assets/images/Brochure_Neuroelectrics/16.png'
import Footer from '../components/footer'
import ClientThree from '../components/client-three'
import TeamOne from '../components/team-one'
import { feature } from '../data'
import health2 from '../assets/images/health/04.png'
import Partner from '../components/partner'
import Icocnrc from '../components/mi_icono'
import { LuAccessibility, LuCheckCircle, LuImport, LuInfo } from 'react-icons/lu'
import { motion } from 'framer-motion'
import ShapeTwo from '../components/shape-two'
import VideoBackground from '../components/video-background';
import videoFondo from '../assets/video/redes2.mp4'; // O de tu carpeta public
import ModernPortfolio from '../components/modern-portfolio'
import MesonaryPortfolio from '../components/mesonary-portfolio'

export default function IndexCharity() {
  return (
    <>
     <Navbar navLight={true}/> 
    <VideoBackground videoSrc={videoFondo} playbackRate={1.5}>
    <section className="bg-home d-flex align-items-center" style={{height:'0%'}}>      
       <div className="container">
          <div className="row justify-content-center mt-5">
              <div className="col-lg-12 text-center">
                  <div className="title-heading mt-4">
                      <Icocnrc size={250} color={'#6dc77a'}/>
                      <motion.h1 
                      initial={{ y:25, opacity:0}}
                      animate={{ y:0, opacity:1}}
                      transition={{duration:1, ease:"easeInOut"}}
                      className="heading text-white title-dark fw-normal mb-5"><span className="fw-bold text-primary">CNRC </span><br/> <span className='fw-bold' style={{fontSize:27}}>Centro de Neuromodulación Rehabilitación Cognitiva de Sonora</span></motion.h1>
                      
                  </div>
              </div>
          </div>
      </div>
    </section>
    </VideoBackground>


  <section className="section">       
      <div className="container">
          <div className="row justify-content-center align-items-center">
              <div className="col-md-5 mt-sm-0 pt-2 mb-md-4 pt-sm-0">
                  <div className="section-title">                  
                   
                    <h4  className="title mb-4 text-center"> La salud mental es única, tu tratamiento también <br /> debería serlo.</h4>
                  </div>
              </div>
              <div className="col-md-5 mt-md-4 mt-sm-0 pt-2 mb-4 pt-sm-0">
                  <p className="text-muted" style={{textAlign:'justify', padding:10}}>En el Centro de Neuromodulación Rehabilitación Cognitiva de Sonora buscamos mejorar la actividad nerviosa mediante la aplicación de estímulos, ya sean eléctricos o magnéticos, en puntos específicos del sistema nervioso. Nuestro objetivo principal es normalizar la función del tejido nervioso cuando existe un desequilibrio o disfunción.</p>                  
              </div>              
          </div>
      </div>

   <div className="container mb-60">
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="section-title">                                         
                              <Partner />
                        </div>
                    </div>
                </div>
             
            </div>

 
      <div className="container">
          <div className="row align-items-center">
              <div className="col-md-6 order-1 order-md-2 text-end">
                  <div className="row align-items-center ms-lg-5" style={{padding:10}}>
                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 overflow-hidden">
                                      <img src={intro_11} className="img-fluid" alt="" style={{borderTopLeftRadius:'80px 80px'}} />
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 overflow-hidden">
                                      <img src={intro_01} className="img-fluid" alt="" style={{borderBottomLeftRadius:'80px 80px'}} />
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 overflow-hidden">
                                      <img src={intro_08} className="img-fluid" alt="" style={{borderTopRightRadius:'80px 80px'}} />
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 overflow-hidden">
                                      <img src={intro_torre} className="img-fluid" alt="" style={{borderBottomRightRadius:'80px 80px'}} />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="col-md-6 order-2 order-md-1 mt-80 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title" style={{padding:10}}>
                      <h4
                      className="title mb-4">Servicios<span className="text-primary"></span></h4>

                      <ul className="list-inline mb-0" style={{textAlign:'justify'}}>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Estimulación magnética transcraneal repetitiva (EMTr o rTMS) <p className='text-muted' style={{fontWeight:'normal', paddingTop:'10px'}}>La Estimulación Magnética Transcraneal repetitiva (EMTr), también conocida por sus siglas en inglés como rTMS (repetitive Transcranial Magnetic Stimulation), es un procedimiento médico no invasivo que utiliza campos magnéticos para estimular las células nerviosas en el cerebro. <br />La rTMS es una técnica segura y eficaz para modular la actividad cerebral y ofrecer una alternativa terapéutica para pacientes que no han respondido a los tratamientos convencionales.</p>
                            <div className="mt-3">
                              <Link className="text-primary" to="/emt">Más información<i className="mdi mdi-chevron-right align-middle"></i></Link>
                            </div>
                          </li>
                          <br />
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Estimulación eléctrica transcraneal por corriente directa (tDCS) <p className='text-muted' style={{fontWeight:'normal', paddingTop:'10px'}}> La Estimulación eléctrica transcraneal por corriente directa (tDCS) es una técnica de neuromodulación no invasiva que utiliza una corriente eléctrica de baja intensidad para estimular o inhibir la actividad cerebral. <br />Es una técnica de costo accesible y fácil aplicación que modula la actividad cerebral para objetivos terapéuticos o de investigación, ofreciendo un enfoque complementario en el tratamiento de diversas condiciones neurológicas y psiquiátricas. </p> 
                           <div className="mt-3">
                              <Link className="text-primary" to="/dcs">Más información<i className="mdi mdi-chevron-right align-middle"></i></Link>
                            </div>                          
                          </li>
                        </ul>                     
                  </div>
              </div>
          </div>
      </div>
    </section>


    <section className="pb-4 bg-light" id="cause">
      <div className="container">     
         <div className="row justify-content-center" style={{padding:10}}>
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                        <h4
                      className="title mt-5 mb-4">Trastornos <span className='text-warning' style={{textDecoration:'underline'}}>psiquiátricos</span></h4>
                      
                      <p className="text-muted mx-auto mb-0" style={{textAlign:'justify'}}>Para que una alteración sea considerada un trastorno psiquiátrico, generalmente debe estar asociada a angustia o a discapacidad funcional en áreas importantes de la vida, como el trabajo, la escuela, las relaciones personales o la capacidad para afrontar el día a día. Es decir, no se trata solo de sentirse mal ocasionalmente, sino de un patrón de síntomas que causan un impacto negativo y persistente en el bienestar y el funcionamiento de la persona.</p>
                     
                  </div>
                   <p className="text-secondary mx-auto mb-0" style={{textAlign:'left'}}>Tratamos a pacientes con:</p>
              </div>
          </div>
          <div className="row" style={{marginBottom:'20px'}}>
              <ClientThree/>          
          </div>         
      </div>
    </section>

       <section className="pt-5" id="cause" style={{marginBottom:'0px'}}>

          <div className="container" style={{padding:30}}>
            <div className="rounded-5 pb-lg-0 pb-sm-0" style={{boxShadow:'0 0.5rem 1rem rgba(0, 0, 0, 0.15)'}}>
                <div className="row justify-content-center align-items-center">
                    <div className="col-12 px-5 my-4" style={{padding:10}}>
                        <div className="text-start">
                            <h2 className="text-dark title-dark text-center">Tu primera evaluación <span className='text-warning' style={{textDecoration:'underline'}}>gratis</span></h2>
                            <p className="text-dark-50 para-dark mt-4 mb-4" style={{textAlign:'justify'}}>En el Centro de Neuromodulación Rehabilitación Cognitiva de Sonora recibirá sin costo una sesión informativa sobre los tratamientos de neuromodulación. 
                            </p>
                            <div style={{textAlign:'center'}}>
                                <Link to="/contacto" className="btn btn-success rounded">Agendar evaluación</Link>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>    
      </section>


     <section id="cause" style={{marginBottom:'50px', marginTop:'50px'}}> 
          <div className="container ">
                  <div className="row justify-content-center">
                      <div className="col-12 text-center">
                          <div className="section-title">
                              <h4 className="title mb-4">Ventajas y beneficios</h4>  
                          </div>
                      </div>
                  </div>
        
                  <div className="row">
                    {feature.map((item,index)=>{
                      let Icon = item.icon
                      return(
                          <div className="col-lg-3 col-md-4 col-12" key={index}>
                              <div className="feature p-3 py-4 rounded text-center">
                                  <div className="content">
                                      <Icon className="text-primary" style={{fontSize:45}} />
                                      <h4 className="title mt-3">{item.title}</h4>
                                      <p className="text-muted mt-2 mb-0" style={{textAlign:'justify'}}>{item.desc}</p>
                                  </div>
                              </div>
                          </div>
                      )
                    })}
                  </div>
              </div>    
    </section>
    
 
    
    <section className="bg-light" id="cause" style={{paddingTop:'50px', paddingBottom:'50px'}}> 
     <div className="container">
          <div className="row align-items-center">
             <div className="col-12 px-5">
                  <div className="section-title ms-md-2" >
                      <h4 className="title mb-4 text-dark text-left">Consideraciones <span className='text-warning' style={{textDecoration:'underline'}}>importantes</span></h4>
                      <p className="text-muted" style={{textAlign:'justify'}}>La neuromodulación es una herramienta poderosa y en crecimiento para el tratamiento de diversas condiciones, especialmente aquellas relacionadas con el dolor crónico y trastornos neurológicos, ofreciendo una alternativa valiosa para mejorar la calidad de vida de los pacientes.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6 text-primary" style={{textAlign:'justify'}}><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Seguridad y efectividad <p className='text-muted' style={{fontWeight:'normal'}}>Es una técnica segura y efectiva en manos de profesionales capacitados, pero requiere de una valoración previa.</p></li>
                          <li className="h6 text-primary" style={{textAlign:'justify'}}><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Contraindicaciones <p className='text-muted' style={{fontWeight:'normal'}}>Generalmente no se recomienda en pacientes con dispositivos eléctricos implantados (marcapasos) y/o durante el primer trimestre del embarazo.</p></li>
                          <li className="h6 text-primary" style={{textAlign:'justify'}}><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Investigación en curso <p className='text-muted' style={{fontWeight:'normal'}}>Es un área en constante evolución, con nuevas aplicaciones y mejores técnicas.</p></li>
                      </ul>    
                </div>
              </div>
          </div>
      </div>
</section>
    
<section id="cause" style={{paddingBottom:'0px'}}>    
   <div className="container mt-80 mb-60">
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="section-title">
                            <h4 className="title mb-4">Equipo de trabajo</h4>
                            <p className="text-muted mx-auto mb-0" style={{maxWidth:'800px', textAlign:'center'}} >En CNRC de Sonora, nuestro verdadero propósito es transformar la vida de las personas que sufren condiciones debilitantes, devolviéndoles la funcionalidad, el alivio del dolor y, en última instancia, una mejor calidad de vida a través de soluciones neurológicas avanzadas y personalizadas.</p>
                        </div>
                    </div>
                </div>
                <TeamOne />
            </div>
    </section>  

 <section className="section" style={{paddingTop:'30px'}}>
      <div className="container">
       <div className="row">
                    <div className="col-12 text-center">
                        <div className="section-title">
                            <h5 className="mb-5"> <LuCheckCircle /> Nuestras <span className='text-primary' style={{textDecoration:'underline'}}>instalaciones</span></h5>                            
                        </div>
                    </div>
                </div>
              <MesonaryPortfolio grid="col-lg-12" row="column-5"/>
      </div>
    </section>

    <Footer/>
    </>
  )
}
